import base from "./data/municipiosLimitrofesRJ.json";

const normalizar = valor => String(valor || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().replace(/\s+/g, " ").toUpperCase();

export const sedesMunicipaisRJ = Object.entries(base.municipios)
  .filter(([, municipio]) => municipio.uf === "RJ")
  .map(([codigo, municipio]) => ({ codigo, nome: municipio.nome }))
  .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));

export function conferirMunicipios(sedeCodigo, destinoTexto, tipoDiaria = "") {
  const resultado = { situacao: "INCONCLUSIVO", fonte: base.fonte, versao: base.versao };
  const sede = base.municipios[sedeCodigo];
  if (!sede || !Array.isArray(sede.limitrofes)) return resultado;
  const texto = normalizar(destinoTexto);
  const partes = texto.match(/^(.*?)(?:\s*[/,-]\s*([A-Z]{2})|\s*\(([A-Z]{2})\))?$/);
  const nome = partes ? partes[1].trim() : texto;
  const uf = partes ? partes[2] || partes[3] || "" : "";
  const dentroRJ = tipoDiaria === "Nacional (Dentro do Estado do RJ)";
  if (!uf && !dentroRJ && base.nomesAmbiguos.includes(nome)) return resultado;
  const candidatos = Object.entries(base.municipios).filter(([, municipio]) =>
    normalizar(municipio.nome) === nome && (!uf || municipio.uf === uf) &&
    (uf || !dentroRJ || municipio.uf === "RJ"));
  if (candidatos.length !== 1) return resultado;
  const [codigo, destino] = candidatos[0];
  return {
    ...resultado,
    sede: `${sede.nome}/${sede.uf}`,
    destino: `${destino.nome}/${destino.uf}`,
    situacao: codigo === sedeCodigo ? "MESMO_MUNICIPIO" : sede.limitrofes.includes(codigo) ? "LIMITROFE" : "NAO_LIMITROFE",
  };
}
